import { render, staticRenderFns } from "./AddNewCourse.vue?vue&type=template&id=9950791e&"
import script from "./AddNewCourse.vue?vue&type=script&lang=js&"
export * from "./AddNewCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports